import { render, staticRenderFns } from "./AccessesCrud.vue?vue&type=template&id=21446738&scoped=true"
import script from "./AccessesCrud.vue?vue&type=script&lang=js"
export * from "./AccessesCrud.vue?vue&type=script&lang=js"
import style0 from "./AccessesCrud.vue?vue&type=style&index=0&id=21446738&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21446738",
  null
  
)

export default component.exports